import { isArray as _isArray } from 'lodash';

import {
  DASHBOARDS_BASE_URL,
  DOCUMENTS_BASE_URL,
  DOCUMENTS_PATHS,
  USER_BASE_URL,
  USER_MANAGEMENT_PATHS,
} from '../constants/paths.constant';

export const isDocumentsPath = (path: string): boolean =>
  DOCUMENTS_PATHS.includes(path) || path.startsWith(DOCUMENTS_BASE_URL);

export const isUserManagementPath = (path: string): boolean =>
  USER_MANAGEMENT_PATHS.includes(path) || path.startsWith(USER_BASE_URL);

export const isDashboardsPath = (path: string | readonly string[]): boolean => {
  const paths = _isArray(path) ? path : [path];
  return paths.some((p) => p.startsWith(DASHBOARDS_BASE_URL));
};
